<template>
  <div class="iframe_wrap">
    <iframe
      class="iframeVideo"
      ref="iframe"
      :width="width"
      :height="height"
      scrolling="no"
    ></iframe>
  </div>
</template>

<script>
import Videojs from "video.js"; // 引入Videojs
// import uuid from "uuid-js";
import { getFileName, waitTime } from "@/util/fun.js";
export default {
  props: {
    src: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "500",
    },
    height: {
      type: String,
      default: "300",
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    showMsg: {
      type: Function,
      default: () => {
        return "播放失败";
      },
    },
  },
  data() {
    return {
      options: {
        autoplay: this.autoplay, // 设置自动播放
        controls: true, // 显示播放的控件
        preload: "auto",
        language: "zh-CN",
        // liveDisplay: true,
        // durationDisplay: true,
        sources: [
          // 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了nowPlayVideoUrl也没实现)
          {
            src: "",
            type: "application/x-mpegURL", // 告诉videojs,这是一个hls流
          },
        ],
      },
      videoHtml:
        '<video  class="video-js vjs-default-skin vjs-big-play-centered vjs-live" style="width:100%;height:100%;object-fit:contain"  muted controls></video>',
      video: null,
      player: null,
    };
  },
  created() {},
  mounted() {
    let style =
      "<link rel='stylesheet' href=" +
      window.location.origin +
      "/css/video-js.min.css />";
    let el = this.$refs.iframe;
    console.log(el);
    // let videoHtml =
    //   "<video  class=video-js style=object-fit:contain;" +
    //   "max-height:" +
    //   this.height +
    //   "px;max-width:" +
    //   this.width +
    //   "px" +
    //   "  muted controls></video>";
    el.contentDocument.getElementsByTagName("html")[0].innerHTML =
      "<head>" + style + "</head>" + "<body>" + this.videoHtml + "</body>";
    console.log(el.contentDocument.getElementsByTagName("html")[0]);
    setTimeout(() => {
      el.contentDocument.getElementsByTagName("body")[0].style.margin = 0;
      this.video = el.contentDocument.getElementsByTagName("video")[0];
      this.startPlay(this.src);
    }, 100);
    // el.onload = () => {
    //   console.log("iframe加载成功");
    //   this.video = el.contentDocument.getElementsByTagName("video")[0];
    //   console.log("video", this.video);
    //   //   setIframeHeight(el);
    // };
  },
  beforeDestroy() {
    console.log(
      "销毁前",
      this.another(this.player),
      this.another(this.player.dispose)
    );
    if (this.player && this.player.dispose) {
      try {
        this.player.dispose(); // 该方法会重置videojs的内部状态并移除dom
      } catch (err) {}
    }
  },
  watch: {
    src(val) {
      console.log("播放地址变化了", val);
      let url = val || "";
      if (this.player) {
        let suffix = getFileName(url).suffix;
        let arr = [{ type: "", src: url }];
        if (suffix == "m3u8") {
          arr[0].type = "application/x-mpegURL";
        } else {
          arr[0].type = "";
        }
        this.player.src(arr);
      } else {
        this.startPlay(val);
      }
    },
  },
  methods: {
    async startPlay(_url) {
      let that = this;
      let url = _url || this.src;
      console.log("地址", url);
      if (!url) {
        return;
      }
      let suffix = getFileName(url).suffix;
      if (suffix == "m3u8") {
        this.options.sources[0].type = "application/x-mpegURL";
      } else {
        this.options.sources[0].type = "";
      }
      this.options.sources[0].src = url;
      if (!this.video) {
        await waitTime(50);
        this.startPlay(_url);
        return;
      }
      this.player = Videojs(this.video, this.options, function () {
        this.on("error", function (e, b, c) {
          this.errorDisplay.contentEl().innerText = that.showMsg();
          // console.log(e, b, c);
          // if (_that.item.streamState != 1) {
          //   this.errorDisplay.contentEl().innerText = "直播未开始推流";
          // } else {
          //   this.errorDisplay.contentEl().innerText = "直播无法播放";
          // }
        });
      });
    },
  },
};
</script>

<style lang="scss">
/* ::v-deep .video-js .vjs-tech {
  position: relative !important;
  max-height: 430px !important;
  max-width: 764.45px !important;
  object-fit: contain !important;
} */
/* ::v-deep .video-js video {
  position: relative;
  max-height: 430px !important;
  max-width: 764.45px !important;
  object-fit: contain !important;
} */
/* ::v-deep .livePlayer-dimensions {
  max-height: 430px !important;
  max-width: 764.45px !important;
  width: auto;
  height: auto;
} */
</style>
